import { render, staticRenderFns } from "./CreateGroupBtn.vue?vue&type=template&id=6eb3df20"
import script from "./CreateGroupBtn.vue?vue&type=script&lang=ts"
export * from "./CreateGroupBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports